import PropTypes from "prop-types"
import { Modal, Spin } from "antd"
import { useSelector } from "react-redux"
import ClientContactForm from "pagesV2/pro/clients/ClientsContactWindow"

const TITLE_BY_TYPE = { email: "Send Email", text: "Send Text", message: "Send Message" }

// Thin wrapper that reuses the existing client messaging form (ClientContactForm) for the
// Bookings module. Recipients are rows carrying { userId, user }; the form sends by numeric
// user_id, so rows without one are dropped. Default type "message" renders a body + send.
const SendClientMessageModal = ({ open, onClose, recipients, type, setSelectedRowKeys }) => {
  const { loading } = useSelector((store) => store.clients.sendMessage)

  // Multiple selected reservations can belong to the same person, so collapse recipients by
  // user_id — the message is sent once per client and the UI (count + chips) must show one
  // entry per unique client, not one per booking.
  const clients = recipients
    .filter((recipient) => recipient.userId != null)
    .reduce((unique, recipient) => {
      const userId = Number(recipient.userId)
      if (!unique.some((client) => client.user_id === userId)) {
        unique.push({ user_id: userId, user: recipient.user || null })
      }
      return unique
    }, [])
  const userIds = clients.map((client) => client.user_id)

  return (
    <Modal title={TITLE_BY_TYPE[type] || "Send Message"} width={700} open={open} footer={null} onCancel={onClose} destroyOnClose>
      <Spin spinning={loading}>
        <ClientContactForm
          handleClose={onClose}
          type={type}
          clients={clients}
          userIds={userIds}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </Spin>
    </Modal>
  )
}

SendClientMessageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  recipients: PropTypes.arrayOf(
    PropTypes.shape({
      userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      user: PropTypes.object
    })
  ),
  type: PropTypes.oneOf(["email", "text", "message"]),
  setSelectedRowKeys: PropTypes.func
}

SendClientMessageModal.defaultProps = {
  recipients: [],
  type: "message",
  setSelectedRowKeys: undefined
}

export default SendClientMessageModal
